import { HTMLProps } from 'react'
import { css, styled } from 'styled-components'

import checkmark from '../../images/svg/checkmark.svg?raw'

const StyledCheckbox = styled.input`
  appearance: none;
  flex-shrink: 0;

  height: ${(p) => p.theme.typography.sizes.md}px;
  width: ${(p) => p.theme.typography.sizes.md}px;

  padding: 2px;
  vertical-align: middle;
  fill-opacity: 0;
  border-radius: 4px;

  background-color: ${(p) => (p.checked ? p.theme.colors.grayscale.black : 'transparent')};
  border: 1px solid
    ${(p) => (p.checked ? p.theme.colors.grayscale.black : p.theme.colors.grayscale.black)};

  ${(p) =>
    p.checked
      ? css`
          background-image: url(data:image/svg+xml,${encodeURIComponent(checkmark)});
          background-repeat: no-repeat;
        `
      : null}

  box-shadow: none;

  transition:
    background-color 200ms ease-in-out 0s,
    border-color 200ms ease-in-out 0s;
`

const Checkbox: FC<HTMLProps<HTMLInputElement>> = ({ children, checked, ...props }) => {
  return (
    <StyledCheckbox type='checkbox' checked={checked} readOnly {...props}>
      {children}
    </StyledCheckbox>
  )
}

export default Checkbox
